"use strict";
/* eslint-disable no-var */
/*
 * This file sets the __webpack_public_path__ which tells webpack the CDN base url
 * from which to load assets and resources (like images, lazy loaded scripts).
 * The CDN base url is served identically by both ECS payloads: Planner Client ECS as
 * planner.sessionmetadata.publicPath and Teams Tasks ECS as msTeamsTasks.config.PublicPath.
 * We prefer Planner Client ECS and fall back to Teams Tasks ECS while it is still served,
 * so removing window.msTeamsTasks is a no-op.
 * See: https://webpack.js.org/guides/public-path/#on-the-fly
 */
function getPlannerPublicPath() {
    const plannerGlobal = Reflect.get(globalThis, "planner");
    if (!plannerGlobal || typeof plannerGlobal !== "object" || !("sessionmetadata" in plannerGlobal)) {
        return undefined;
    }
    const sessionMetadata = plannerGlobal.sessionmetadata;
    if (!sessionMetadata || typeof sessionMetadata !== "object" || !("publicPath" in sessionMetadata)) {
        return undefined;
    }
    return typeof sessionMetadata.publicPath === "string" ? sessionMetadata.publicPath : undefined;
}
const plannerPublicPath = getPlannerPublicPath();
const ttPublicPath = typeof msTeamsTasks !== "undefined" ? msTeamsTasks?.config?.PublicPath : undefined;
__webpack_public_path__ = plannerPublicPath || ttPublicPath;
